import GenericDB from './generic-db';

export default class ClinicsDB extends GenericDB {
  constructor() {
    super('clinics');
  }

  // Here you can extend ClinicsDB with custom methods
}
